export const AUTH_TOKEN = 'Authorization';

export const LOCAL_STORAGE = {
  ID_TOKEN: 'token',
  USER: 'user',
};

export const MAIN_EVENTS = ['Main Events', 'Important Games']

export const PAGE_TITLES: any = {
  WEBSITE_TITLE: 'Sportsfeed24 - Todays Soccer Streams, Reddit NFL Streams, NBA Streams, UFC Fight Night, Boxing, and More',
  HOME: 'Sportsfeed24 - Home to Football Streams, Soccer Fixtures, Reddit Soccer Streams, and Live Sports Coverage',
  SOCCER: 'Watch 100% original Quality Soccer Streams and Live Football Matches | Sportsfeed24',
  BOXING: 'Sportsfeed24 - Reddit Boxing Streams and Upcoming Boxing Matches',
  NFL: 'Sportsfeed24 - Reddit NFL Streams, Live NFL Games, and Upcoming NFL Fixtures',
  NBA: 'Sportsfeed24 - Reddit NBA Streams, NBA Live Coverage and stream Links',
  UFC: 'Sportsfeed24 - Reddit UFC Streams, UFC Fight Night, and Upcoming UFC Main Event',
  TENNIS: 'Sportsfeed24 - Live Tennis Streams and Tennis Match Fixtures',
  RUGBY: 'Sportsfeed24 - Live Rugby Streams and Match Schedules',
  MOTOGP: 'Sportsfeed24 - Free MotoGP Streams and Race Schedule',
  NHL: 'Sportsfeed24 - NHL Live Streams, Games, and Fixtures',
  MLB: 'Sportsfeed24 - MLB Live Streams and Upcoming Matches',
  F1: 'Sportsfeed24 - F1 Reddit Streams, Formula 1 Events, and live Coverage',
  MLS: 'Sportsfeed24 - MLS Live Streams and Upcoming Matches',
  CRICKET: 'Sportsfeed24 - Cricket Streams, Match Schedules and ICC tournaments',
  TEAMS: 'Sportsfeed24 - Team Fixtures, Match Schedules, and Live Streams',
  LEAGUES: 'Sportsfeed24 - Major League Fixtures, Live Soccer Streams, and Upcoming soccer matches',
  STANDINGS: 'Sportsfeed24 - Major League Tables: Premier League standing, Champions League Table, LaLiga, Serie A, Bundesliga',
  CONTACT: 'Sportsfeed24 - Reach out to Us, Give Feedback, and Suggestions',
  ABOUT: 'What is Sportsfeed24? Know more about this platform'
}

export const CATEGORY_LINKS:any = {
  HOME: '/',
  F1: '/fixtures/F1/F1',
  UFC: '/fixtures/UFC/UFC',
  'BOXING|UFC': '/fixtures/Boxing/Boxing',
  BOXING: '/fixtures/Boxing/Boxing',
  TENNIS: '/fixtures/tennis/tennis',
  NBA: '/fixtures/NBA/NBA',
  NFL: '/fixtures/NFL/NFL',
  RUGBY: '/fixtures/Rugby/Rugby',
  CRICKET: '/fixtures/Cricket/Cricket',
  MOTOGP: '/fixtures/motogp/MOTOGP'
};

export const MESSAGES = {
  EMAIL_SUCCESS: 'Your email has been sent successfully!',
  EMAIL_FAILURE: 'Unable to sent email!',
  ADD_STREAM_SUCCESS: 'Player added successfully!',
  ADD_STREAM_FAILURE: 'Failed to add player!',
  UPDATE_STREAM_SUCCESS: 'Streams updated successfully!',
  UPDATE_STREAM_FAILURE: 'Failed to add sreeams!',
  AUTH_SUCCESS: 'User Authenticated!',
  AUTH_FAILURE: 'Invalid user or password!'
}

export const categories = [
  {
    label: 'home',
    value: 'Streams today'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'tennis',
    value: 'tennis'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'UFC',
    value: 'UFC'
  },
  {
    label: 'motogp',
    value: 'motogp'
  },
  {
    label: 'NFL',
    value: 'NFL'
  },
  {
    label: 'NBA',
    value: 'NBA'
  },
  {
    label: 'Rugby',
    value: 'Rugby'
  },
  {
    label: 'Cricket',
    value: 'cricket'
  },
  {
    label: 'MLB',
    value: 'MLB'
  },
  {
    label: 'NHL',
    value: 'NHL'
  }
];

export const CATGORY_LINKS = [
  { label: 'Soccer', link: '/soccer' },
  { label: 'NFL', link: '/fixtures/NFL/NFL' },
  { label: 'F1', link: '/fixtures/F1/F1' },
  { label: 'UFC', link: '/fixtures/UFC/UFC' },
  { label: 'Boxing', link: '/fixtures/Boxing/Boxing' },
  { label: 'tennis', link: '/fixtures/tennis/tennis' },
  { label: 'NBA', link: '/fixtures/NBA/NBA' },
  { label: 'Rugby', link: '/fixtures/Rugby/Rugby' },
  // { label: 'Cricket', link: '/fixtures/Cricket/Cricket' },
  { label: 'motogp', link: '/fixtures/motogp/MOTOGP' },
  // { label: 'mlb', link: '/fixtures/MLB/MLB' },
  // { label: 'nhl', link: '/fixtures/NHL/NHL' },
];

export const ADS = {
  MAIN: {
    TYPE: 'main',
    SLOT: '2554300823'
  },
  FIXTURE_LIST_DISPLAY_HORIZONTAL: {
    TYPE: 'FixtureListDisplayHorizontal',
    SLOT: '3824669050'
  },
  PLAYER_DISPLAY_HORIZONTAL: {
    TYPE: 'playerDisplayHorizontal',
    SLOT: '3744778007'
  },
  VERTICLE_MAIN: {
    TYPE: 'vertical',
    SLOT: '2926488530'
  },
  IN_ARTICLE: {
    TYPE: 'in-article',
    SLOT: '6685754230'
  },
  IN_FEED: {
    TYPE: 'in-feed',
    SLOT: '2184823320'
  },
  SQUARE_DISPLAY: {
    TYPE: 'square-display',
    SLOT: '7807264218'
  },
}

export const DIRECT_PLAYERS = [
  'TNT SPORTS FHD',
  'TNT SPORTS 1080P',
  'MLB PASS 1080P'
  // 'rSoccerlink'
];

export const GREEN_PLAYER_SOURCES = [
  'Reddit-SoccerStreams', 
  'Reddit-Streams', 
  'TNT Sports 2 Uk', 
  'ESPN 2 USA', 
  'Full Hd Sports',
  'wow STREAM',
  'NBA TV',
  'NBA TV USA'
]

export const NOT_SOCCER = ['tennis', 'cricket', 'f1', 'boxing|ufc', 'nfl', 'motogp','nba', 'nhl', 'mlb', 'rugby', 'wwe','ufc'];
export const DEFAULT_LEAGUE_LINK = '/fixtures/league/Premier League';
export const DEFAULT_TEAM_LINK = '/fixtures/team/Liverpool';
export const LOGO_URL = 'https://d22vy4ldq8bjtm.cloudfront.net/images/special/Sportsfeed24-Logo-Official.webp';
// export const EVERYGAME_POKER = 'https://d22vy4ldq8bjtm.cloudfront.net/images/affiliate/everygamePoker.webp';
export const BCAFFILIATELINK = 'https://bc.game/i-2p0fdhyng-n/';

export const AFFILIATE_BANNERS = {
  HOME_WEB: {
    TOP: [
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/1352x166.gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/1352x166.gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/460x90.gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/728x90+(1).gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/970x250+(1).gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/970x250.gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/bcgame.PNG',
    ],
    SIDE: [
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/300x600.gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/300x600+(1).gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/Crash_game_280x300.gif'
    ]
  },
  HOME_MOBILE: {
    TOP: [
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/390x90.gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/460x90.gif',
      'https://d22vy4ldq8bjtm.cloudfront.net/gifs/Crash_game_280x300.gif'
    ]
  }
} 
